export enum ErrorType {
  REQUIRED = 'REQUIRED',
  WRONG_LIST_SIZE = 'WRONG_LIST_SIZE',
  RANGE = 'RANGE',
  INVALID_VALUE = 'INVALID_VALUE',
  OTHER = 'OTHER',
  UNEXPECTED_VALUE = 'UNEXPECTED_VALUE'
}


export class ValidationError {
  key: string;
  errorType: ErrorType;
  fieldId?: number;
  fieldValue?: string;

  constructor(key: string, errorType: ErrorType, fieldId?: number, fieldValue?: string) {
    this.key = key;
    this.errorType = errorType;
    this.fieldId = fieldId;
    this.fieldValue = fieldValue;
  }


  static deserialize(json: any): ValidationError {
    const errorType = json['errorType'] as ErrorType;
    switch (errorType) {
      case ErrorType.REQUIRED:
        return new RequiredError(json.key);
      case ErrorType.WRONG_LIST_SIZE:
        return new WrongListSizeError(json.key, json.actual, json.expected);
      case ErrorType.INVALID_VALUE:
        return new InvalidValueError(json.key, json.invalidValue, json.validValues, json.codebookMapping);
      case ErrorType.RANGE:
        return new RangeError(json.key, json.min, json.max);
      case ErrorType.UNEXPECTED_VALUE:
        return new UnexpectedValueError(json.key, json.unexpectedValue);
      case ErrorType.OTHER:
        return new CommonError(json.key, json.translationMessageKey)
      default:
        return new ValidationError(json.key, errorType, json.fieldId, json.fieldValue);
    }
  }

}

export class InvalidValueError extends ValidationError {
  invalidValue: any;
  validValues: any[];
  codebookMapping: boolean;

  constructor(key: string, invalidValue: any, validValues: any[], codebookMapping: boolean) {
    super(key, ErrorType.INVALID_VALUE);
    this.invalidValue = invalidValue;
    this.validValues = validValues;
    this.codebookMapping = codebookMapping;
  }

}

export class UnexpectedValueError extends ValidationError {
  unexpectedValue: any;

  constructor(key: string, unexpectedValue: any) {
    super(key, ErrorType.UNEXPECTED_VALUE);
    this.unexpectedValue = unexpectedValue;
  }

}


export class RequiredError extends ValidationError {
  constructor(key: string) {
    super(key, ErrorType.REQUIRED);
  }
}

export class WrongListSizeError extends ValidationError {
  actual: number;
  expected: number;

  constructor(key: string, actual: number, expected: number) {
    super(
      key,
      ErrorType.WRONG_LIST_SIZE,
    );
    this.actual = actual;
    this.expected = expected;
  }
}

export class RangeError extends ValidationError {
  min: any;
  max: any;

  constructor(key: string, min: any, max: any) {
    super(
      key,
      ErrorType.RANGE,
    );
    this.min = min;
    this.max = max;
  }
}

export class CommonError extends ValidationError {
  translationMessageKey: string;

  constructor(key: string, translationMessageKey: string) {
    super(
        key,
        ErrorType.OTHER,
    );
    this.translationMessageKey = translationMessageKey;
  }
}

export class ValidatorResult {
  errors?: ValidationError[];
  nestedResults?: NestedResult[];

  constructor() {
    this.errors = [];
    this.nestedResults = [];
  }

  static deserialize(json: any): ValidatorResult {
    const instance = new ValidatorResult();
    instance.errors = json.errors?.map((error: any) => ValidationError.deserialize(error)) || [];

    instance.nestedResults = json.nestedResults?.map((nested: any) => {
      return {
        key: nested.key,
        fieldId: nested.fieldId,
        fieldValue: nested.fieldValue,
        result: ValidatorResult.deserialize(nested.result)
      };
    }) || [];
    return instance;
  }

  public hasErrors(): boolean {
    if (this.errors && this.errors.length > 0) return true;
    if (this.nestedResults) {
      return this.nestedResults.some(nested => nested.result?.hasErrors());
    }
    return false;
  }
}

export interface NestedResult {
  key: string;
  result: ValidatorResult;
  fieldId?: number;
  fieldValue?: string;
}





